import Fade from "react-reveal/Fade";
import { FaInstagram, FaWhatsapp } from "react-icons/fa";

export default function SectionEight() {
  return (
    <div className="flex flex-col text-center md:space-y-10 space-y-5">
      <Fade bottom>
        <h1 className="md:text-4xl text-3xl font-bold">TUNGGU APALAGI?</h1>
        <a
          href="https://api.whatsapp.com/send?phone=628974525222&text=Halo%20kak!%20Saya%20tertarik%20untuk%20konsultasi%20pembuatan%20logo%20di%20Creatifa%20Studio%20%0A%0ANama%20Saya%20%3A%0ABisnis%20Saya%20%3A%0ABergerak%20di%20Bidang%20%3A%0ALokasi%20%3A%0AWebsite%20%2F%20Sosmed%20Bisnis%20Saya%20%3A%0AEmail%20Saya%20%3A"
          className="md:w-7/12 w-10/12 mx-auto rounded-full bg-yellow-500 md:pb-5 pb-3 hover:pb-0 transition-all"
        >
          <div className="rounded-full bg-red-creatifa md:py-10 py-5 md:px-5">
            <h1 className="text-white text-center md:text-6xl text-3xl font-bold">
              KONTAK KAMI SEKARANG
            </h1>
          </div>
        </a>
        <div className="grid md:w-8/12 w-10/12 mx-auto md:grid-cols-2 grid-cols-1 text-white gap-4">
          <div className="flex justify-center">
            <a
              href="https://www.instagram.com/creatifastudio/"
              target="_blank"
              rel="noreferrer"
            >
              <p className="md:text-4xl text-3xl inline-flex space-x-5 hover:text-red-creatifa">
                <FaInstagram /> <span>creatifastudio</span>
              </p>
            </a>
          </div>
          <div className="flex justify-center">
            <a
              href="https://api.whatsapp.com/send?phone=628974525222&text=Halo%20kak!%20Saya%20tertarik%20untuk%20konsultasi%20pembuatan%20logo%20di%20Creatifa%20Studio%20%0A%0ANama%20Saya%20%3A%0ABisnis%20Saya%20%3A%0ABergerak%20di%20Bidang%20%3A%0ALokasi%20%3A%0AWebsite%20%2F%20Sosmed%20Bisnis%20Saya%20%3A%0AEmail%20Saya%20%3A"
              target="_blank"
              rel="noreferrer"
            >
              <p className="md:text-4xl text-3xl inline-flex space-x-5 hover:text-red-creatifa">
                <FaWhatsapp /> <span>08974525222</span>
              </p>
            </a>
          </div>
        </div>
      </Fade>
    </div>
  );
}
